module.exports = __webpack_public_path__ + "img/R.b067990f.png";